const {  createSlice} = require("@reduxjs/toolkit");

const initialState={
    user:{
      "group": {},
      "permissions": [],
      "roleAllocations": []
      },
    certificate : {},
    token:"",
    plans: {}
}

const userSlice  = createSlice({
  name:"userSlice",
  initialState,
  reducers:{
      saveUserData:(state,action)=>{
        state.user = action.payload.user;
        state.token = action.payload.token;
      },
      saveUserPlan:(state,action)=>{
        state.plans= action.payload
      },
      saveCertificate:(state,action)=>{
        state.certificate = action.payload;
      },
      removeUser:(state)=>{
        state.user = {};
        state.token = "";
      }
  },

});

export const { saveUserData, removeUser, saveCertificate, saveUserPlan } = userSlice.actions;
export default userSlice.reducer;